import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ResourceSchedulingOption", webpackPrefetch: false */ './lazyIndex')
);

export const lazyInitResourceSchedulingSetting = new LazyAction(
    lazyModule,
    m => m.initResourceSchedulingSetting
);

export { default as ResourceSchedulingOption } from './ResourceSchedulingOption';
export { default as ResourceSchedulingPermissions } from './ResourceSchedulingPermissions';
export { default as ResourceSchedulingResponse } from './ResourceSchedulingResponse';
